<div class="background">
  <div class="container">
    <div class="status-icon" [class.status-icon--error]="showError" [class.status-icon--loading]="isLoading">
      <img *ngIf="showSuccess" src="/assets/vectors/success.svg" alt="Success icon">
      <img *ngIf="showError" src="/assets/vectors/error.svg" alt="Error icon">
      <div *ngIf="isLoading" class="loader" aria-label="Loading"></div>
    </div>

    <h1 class="title">{{titleKey | translate}}</h1>
    <p class="info">{{descriptionKey | translate}}</p>

    <div *ngIf="showError" class="alert alert-danger" role="alert">
      {{errorMessage | translate}}
    </div>

    <div *ngIf="showSuccess" class="alert alert-success" role="alert">
      {{'general.confirm_email_success_alert' | translate}}
    </div>

    <div class="actions" *ngIf="!isLoading">
      <a class="btn btn-primary" [routerLink]="['/sign-in']">
        {{'general.back_to_signin' | translate}}
      </a>
    </div>
  </div>
</div>
